import { render } from "./Error404View.vue?vue&type=template&id=28dca660"
import script from "./Error404View.vue?vue&type=script&lang=js"
export * from "./Error404View.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__